import { defineAction } from 'redux-define';

const rootCreator = defineAction('takemetour-partner');

export const promiseStates = ['PENDING', 'RESOLVED', 'REJECTED'];
export default (namespace) => (action, isContainPromiseStates) =>
  (isContainPromiseStates ? rootCreator.defineAction(namespace).defineAction(action, promiseStates)
    : rootCreator.defineAction(namespace).defineAction(action).toString());



// WEBPACK FOOTER //
// ./src/utils/constantCreator.js